export function extensionFromContentType(contentType: string | null | undefined): string {
  const mime = (contentType || '').split(';')[0].trim().toLowerCase()
  if (mime === 'image/png') return 'png'
  if (mime === 'image/webp') return 'webp'
  return 'jpeg'
}

export type OriginalImageBytes = {
  bytes: ArrayBuffer
  extension: string
  contentType: string
}

/**
 * Download the stored S3 object as-is. Paid zips must not canvas-re-encode
 * (canvas q=1.0 is often larger and slower than the jpegli master).
 */
export async function fetchOriginalImageBytes(
  url: string,
  fetchImpl: typeof fetch = fetch,
): Promise<OriginalImageBytes> {
  const response = await fetchImpl(url)
  if (!response.ok) {
    throw new Error(`Unable to download image (${response.status})`)
  }
  const contentType = response.headers.get('content-type') || 'image/jpeg'
  return {
    bytes: await response.arrayBuffer(),
    extension: extensionFromContentType(contentType),
    contentType,
  }
}
